import { Button, message, Popconfirm } from 'antd';
import { useTranslate } from '@tolgee/react';
import { tradeAcceptOfferV1 } from 'services/api/return';
import posthog from '@leyan/lytics';
import { ButtonProps } from 'antd/es/button';
import { getApiErrorCodeMsg } from 'services/api/utils/errorCode';
import { formatNumber } from 'utils/numberFormat';

/** 接受提案: 接受买家提案 */
const ProposeAccept = (
  props: Omit<ButtonProps, 'onClick'> & {
    returnSn: string;
    unit: string;
    latestOfferAmount: number;
    onSuccess?: () => void;
  },
) => {
  const { t } = useTranslate();
  const { returnSn, unit, latestOfferAmount, onSuccess, ...btnProps } = props;

  const accept = () => {
    const reqData = {
      returnExternalId: returnSn,
      operate: 'ACCEPT_OFFER',
    };
    tradeAcceptOfferV1(reqData)
      .then(() => {
        posthog.capture('$returnRst', {
          custRreport: {
            opType: 'ACCEPT_OFFER',
            status: 'ok',
            reqData,
          },
        });
        onSuccess?.();
      })
      .catch((e) => {
        posthog.capture('$returnRst', {
          custRreport: {
            opType: 'ACCEPT_OFFER',
            status: 'err',
            errTip: e.message,
            reqData,
          },
        });
        message.error(getApiErrorCodeMsg(e.response));
      });
  };

  return (
    <Popconfirm
      title={t('trade.接受买家提案提示', {
        money: `${unit}${formatNumber(latestOfferAmount, '0,0.00')}`,
      })}
      onConfirm={accept}
    >
      <Button size="small" {...btnProps}>
        {t('trade.接受买家提案')}
      </Button>
    </Popconfirm>
  );
};

export default ProposeAccept;
